// 引入加密包(注意存放的路径)
aesjs = require("clover/utils/aes/index.js");

EncryptedTool = {
    isBase64(str) {
        const regex = /^(?:[A-Za-z0-9+\/]{4})*(?:[A-Za-z0-9+\/]{2}==|[A-Za-z0-9+\/]{3}=)?$/;
        return regex.test(str);
    },
    base64ToArrayBuffer(base64str) {
        var binary_string = Base64.atob(base64str);
        var len = binary_string.length;
        var bytes = new Uint8Array(len);
        for (var i = 0; i < len; i++) {
            bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes;
    },

    arrayBufferToBase64(buffer) {
        var binary = '';
        var bytes = new Uint8Array(buffer);
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        // 对二进制字符串进行Base64编码
        return Base64.btoa(binary);
    },
    xor_password: "test",
    xorEncrypt(input, password) {
        let key = password ? password : this.xor_password
        let output = '';
        for (let i = 0; i < input.length; i++) {
            // 使用按位异或运算符 ^ 进行加密/解密
            output += String.fromCharCode(input.charCodeAt(i) ^ key.charCodeAt(i % key.length));
        }
        return output;
    },
    xorDecrypt(input, password) {
        return this.xorEncrypt(input, password);
    },
    // 加密 返回base64字符串
    aesEncrypt(text, key, iv) {
        // 将文本转换为字节数组
        const textBytes = aesjs.utils.utf8.toBytes(text)
        // 使用 AES-CBC 模式进行加密
        const aesCbc = new aesjs.ModeOfOperation.cbc(key, iv)
        const encryptedBytes = aesCbc.encrypt(aesjs.padding.pkcs7.pad(textBytes))
        let encryptedText = this.arrayBufferToBase64(encryptedBytes)
        // cc.log("aesEncrypt encryptedText ", encryptedText)
        return encryptedText
    },
    // 解密 text为base64字符串
    aesDecrypt(text, key, iv) {
        const aesCbcDec = new aesjs.ModeOfOperation.cbc(key, iv)
        // 将base64文本转为字节数组
        const encryptedBytesForDecryption = this.base64ToArrayBuffer(text)
        // 使用 AES-CBC 模式进行解密
        const decryptedBytes = aesCbcDec.decrypt(encryptedBytesForDecryption);
        // 去除填充并转换回文本
        // const decryptedText = aesjs.utils.utf8.fromBytes(aesjs.padding.pkcs7.strip(decryptedBytes));
        // const decoder = new TextDecoder('utf-8');
        // const decryptedText = decoder.decode(aesjs.padding.pkcs7.strip(decryptedBytes));
        const decryptedText = this.decodeUTF8(aesjs.padding.pkcs7.strip(decryptedBytes))
        // cc.log("aesEncrypt decryptedText ", decryptedText)
        return decryptedText
    },
    decodeUTF8(arrayBuffer) {
        let result = '';
        const data = new Uint8Array(arrayBuffer);
        let i = 0;
        while (i < data.length) {
            const byte1 = data[i++];
            if (byte1 < 0x80) {
                result += String.fromCharCode(byte1);
            } else if (byte1 < 0xe0) {
                const byte2 = data[i++];
                result += String.fromCharCode(((byte1 & 0x1f) << 6) | (byte2 & 0x3f));
            } else if (byte1 < 0xf0) {
                const byte2 = data[i++];
                const byte3 = data[i++];
                result += String.fromCharCode(((byte1 & 0x0f) << 12) | ((byte2 & 0x3f) << 6) | (byte3 & 0x3f));
            } else {
                const byte2 = data[i++];
                const byte3 = data[i++];
                const byte4 = data[i++];
                let codePoint = (((byte1 & 0x07) << 18) | ((byte2 & 0x3f) << 12) | ((byte3 & 0x3f) << 6) | (byte4 & 0x3f)) - 0x10000;
                result += String.fromCharCode((codePoint >> 10) + 0xd800, (codePoint & 0x3ff) + 0xdc00);
            }
        }
        return result;
    }
}



module.exports = EncryptedTool;